const CLEAN = {
    onReady() {
        let columns = document.querySelectorAll('.layout-block .column');
        columns.forEach(column => {
            CLEAN.addGapToMultiSectionColumn({node: column});
            CLEAN.addMinHeightToLayoutElements({node: column});
            CLEAN.mobileOrder({node: column});
        });
        CLEAN.mobileBackgrounds();
        CLEAN.addGapToLayoutElement();
        CLEAN.coloredList();
        CLEAN.copyrightToggler();
        CLEAN.alignSelf();
        CLEAN.modifyImageContainer();
        CLEAN.showPromoVideo();
    },
    /*********************
    * Order Flex Columns 
    *********************/
    mobileOrder({node}) {
        if (window.innerWidth > 768) return;
        let children = node.querySelectorAll('section');
        let parent   = node.closest('.columns');
        Object.assign(parent.style, {
            marginRight:  '0',
            marginLeft:  '0'
        });
        children.forEach(child => {
            let margin = child.classList.contains('akkordeon') ? '0 auto' : '0 auto 1rem auto';
            Object.assign(child.style, {
                display: 'block',
                width:   '100%',
                margin:  margin
            });
            parent.appendChild(child);
        });
        node.remove();
    },
    /*********************
    * Mobile Backgrounds
    *********************/
    mobileBackgrounds() {
        if (screen.availHeight < screen.availWidth) return; // is landscape
        let sections = document.querySelectorAll('[data-mobile-bg]');
        sections.forEach(section => {
            let imagePath = section.dataset.mobileBg;
            let image     = imagePath.replace('/media/mobile_bg/', '');
            if (image === '') return;
            section.style.backgroundImage = `url("${imagePath}")`;
        });
    },
    /*********************
    * Add Gap to Column Elements
    *********************/
    addGapToMultiSectionColumn({node}) {
        let children = node.childNodes;
        if (node.classList.contains('is-12')) return;
        if (children.length > 1) {
            for (var ii = 0; ii < children.length - 1; ii++) { // exclude last child
                children[ii].style.marginBottom = '1.5rem';
            }
        }
    },
    /*********************
    * Add Min Height to Layout Elements
    *********************/
    addMinHeightToLayoutElements({node}) {
        let layout  = node.closest('.layout-block');
        if (layout === null) return;
        let columns = node.closest('.columns');
        let section = node.firstElementChild;
        if (layout.style.minHeight === '0px') return;
        columns.style.minHeight = layout.style.minHeight;
        section.style.minHeight = layout.style.minHeight;
    },
    /*********************
    * Add Gaps to Columns
    *********************/
    addGapToLayoutElement() {
        let layoutBlocks = document.querySelectorAll('.layout-block');
        layoutBlocks.forEach(block => {
            let columns = document.querySelectorAll('.columns'); 
            columns.forEach(column => {
                column.classList.add(column.closest('.layout-block').dataset.gap)
            });
        });
    },
    /*********************
    * Colored List Items -> Color Marker
    *********************/
    coloredList() {
        let listitems = document.querySelectorAll('li');
        listitems.forEach(item => {
            if (item.firstChild.tagName === 'SPAN' && item.firstChild.style.color !== '') {
                item.style.color = item.firstChild.style.color;
            }
        });
    },
    copyrightToggler() {
        let buttons = document.querySelectorAll('.js-copyright-button');
        buttons.forEach(button => {
            button.addEventListener('click', event => {
                button.nextElementSibling.classList.toggle('is-active');
            });
        });
    },
    alignSelf() {
        let nodes = document.querySelectorAll('[data-align-self]');
        nodes.forEach(node => {
            node.parentNode.classList.add(node.dataset.alignSelf);
        });
    },
    modifyImageContainer() {
        let images = document.querySelectorAll('.text-editor__item img');
        images.forEach(image => {
            let figure = document.createElement('figure');
            figure.className = image.className;
            figure.classList.add('image');
            image.className = '';
            image.parentNode.insertBefore(figure, image);
            figure.appendChild(image);
        });
    },
    showPromoVideo() {
        let anchor   = document.getElementById('promo-video');
        if (anchor === null) return;
        let language = document.getElementById('current-language');
        if (language === null) return;
        let langCode = language.dataset.languageCode;
        var videoId  = anchor.dataset.videoId;
        anchor.addEventListener('click', event => {
            event.preventDefault();
            console.log('Load YT-Video: ' + videoId);
            switch (langCode) {
                case 'de' :
                    videoLangId = 'Hn2D5B-tocw';
                    break;
                case 'en' :
                    videoLangId = 'QTwcN-EEybQ';
                    break;
                case 'es' :
                    videoLangId = 'uqYRH7gF8vA';
                    break;
                case 'hu' :
                    videoLangId = 'l297JsOHE54';
                    break;
                case 'ro' :
                    videoLangId = 'WkEy2rS55yo';
                    break;
                case 'pl' :
                    videoLangId = '-0t-JJhV9uU';
                    break;
                default : // en
                    videoLangId = 'tclSv1hetak';
                    break;
            }
            videoId = videoId == null ? videoLangId : videoId;
            let markup = `<div class="modal is-active">
                <div class="modal-background"></div>
                <div class="modal-content">
                    <figure class="image is-16by9">
                        <iframe 
                            class="has-ratio"
                            width="640" 
                            height="360" 
                            src="https://www.youtube.com/embed/${videoId}" 
                            frameborder="0" 
                            allowfullscreen>
                        </iframe>
                    </figure>
                </div>
                <button class="modal-close is-large" aria-label="close"></button>
            </div>`;
            document.body.insertAdjacentHTML('beforeend', markup);
            MODAL.onReady();
        });
    }
}

